import React, {Component} from 'react'
import {__STREAMING_URL__} from '../../consts/consts';

import { Button,Row,ButtonGroup,Col , Spinner} from 'react-bootstrap';
import Utils from '../../components/Utils';
import ApiCalls from '../ApiCalls';
import Storage from '../Storage';
import ReactPlayer from 'react-player';
import './style.css';
import classnames from 'classnames';
import {miniVideoPlayerShow,miniVideoPlayerHide} from '../../redux/actions/index';
import {
	connect
} from 'react-redux';

export class LiveStreamSelectionTabs extends Component {

    constructor(props){
        super(props);
        let roomSelected = this.props.roomSelected;
        let roomLinkSelected = this.props.roomSelected != null? this.props.roomSelected.videoLink:null
        this.state = {roomSelected:roomSelected,roomLinkSelected:roomLinkSelected,roomList:null,isLoading:true,showSelectionTabs:!this.props.autoHideSelectionTabs}
    }

    onRoomClick(ev){
        if (typeof this.props.onRoomClick != 'undefined' && this.props.onRoomClick != null){
            this.props.onRoomClick(ev);
        }
        else{
            this.props.onRoomClick(ev);
            let roomSelected = this.props.roomList.find(r => r.id == ev.currentTarget.attributes.roomId.value);
            this.setState({roomSelected:roomSelected,roomLinkSelected:roomSelected.videoLink})
            
            //mi codigo aca
        }
    }

    componentDidUpdate(prevProps) {
		//Este metodo se ejecuta cuando redux cambia el estado, me fijo si es otro expositor y renderizo
		 if (prevProps.roomSelected.id != this.props.roomSelected.id)
            this.getRooms();
	} 
  

    getRoomLink(room){
        if (room == null)
            return "";
        return room.videoLink;
        
    }
    componentDidMount(){
        this.getRooms();
    }
    getRoomName(room){
        if (room == null)
            return "";
        switch(this.props.locale){
          case "es":
            return room.name_ES != null ? room.name_ES : room.name
          case "en":
            return room.name_EN != null ? room.name_EN : room.name
          case "pt":
            return room.name_PT != null ? room.name_PT : room.name
          case "fr":
            return room.name_FR != null ? room.name_FR : room.name
          default: 
            return room.name
        }
  
    }

    onMouseEnter(){
        if (this.props.autoHideSelectionTabs == true){
            this.setState({showSelectionTabs:true});
        }
    }

    onMouseLeave(){
        if (this.props.autoHideSelectionTabs == true){
            this.setState({showSelectionTabs:false});
        }
    }

    getRoomLinkCount(room){
        if (room == null)
            return 0;
        let count = 0;
        if (room.videoLink_ES != null  )
            count++;
        if (room.videoLink_EN != null  )
            count++;
        if (room.videoLink_PT != null  )
            count++;
        if (room.videoLink_FR != null  )
            count++;

        return count;
    }

    onRoomVideoLinkClick(ev){
        const videoLink = ev.currentTarget.attributes.roomlink.value;
        this.setState({roomLinkSelected:videoLink})
    }

    openOrCloseMiniVideoPlayer(){
        if (this.props.miniVideoPlayerIsShowing ){
            this.props.miniVideoPlayerHide();
        }
        else{
            this.props.miniVideoPlayerShow();
        }
    }
    getRooms(){
        let me =  this;
        let {roomSelected} = this.props;
      
		 //Me fijo si se seleccionó un room en la url
		//  let urlParams = new URLSearchParams(window.location.search);
		//  let roomSelectedId = urlParams.get('roomId');
		 
        ApiCalls.logOnLiveStreamClick(roomSelected.name);
		 this.setState({
			 isLoading: false,
			 roomSelected:roomSelected!=null?roomSelected:null,
			 roomLinkSelected:roomSelected!=null?roomSelected.videoLink:null})

		
    }

    render(){
        let roomList =  Storage.getRooms();
        if (this.props.roomSelected == null){
            return (<Spinner></Spinner>)
        }
       return (
   
        // className={classnames({
        //     active: activeTab === 'messages',
        //     'nav-link': true,
        //   })}
       <div onMouseEnter={()=>this.onMouseEnter()} onMouseLeave={() => this.onMouseLeave()}>
            <div className={classnames({
        'livestream-selections-tabs-autohide': this.props.autoHideSelectionTabs == true,
        'livestream-selections-tabs-hide':this.state.showSelectionTabs == false
      })}  >
                <Row className="justify-content-md-center">

           
                    <Col sm={8}>
                        <ButtonGroup size="lg" className="mb-2" toggle={true}>
                            {roomList.map( room =>
                                this.getRoomLink(room) == null ? null : 
                                <Button className={"bt-livestream-room bt-livestream-room-"+room.id }active={room.id == this.state.roomSelected.id} key={room.id} roomId={room.id} onClick={(ev)=>this.onRoomClick(ev)} >{this.getRoomName(room)}</Button>
                            )}
                        </ButtonGroup>
                    </Col>
                    {
                    this.props.hideButtonShowMiniVideoPlayer != true?
                    <Col sm={4}>
                        <Button onClick={()=>this.openOrCloseMiniVideoPlayer()}>Ver mini reproductor</Button>
                    </Col>
                    :null
                    }
                
                </Row>
                <Row className="justify-content-md-center">
                    <Col sm={12}>
                    {this.getRoomLinkCount(this.state.roomSelected) > 1?
                            <ButtonGroup size="sm" className="mb-2" toggle={true}>
                        
                                {Utils.renderIf(this.state.roomSelected.videoLink !=null,
                                    <Button active={this.state.roomSelected.videoLink == this.state.roomLinkSelected} key={this.state.roomSelected.videoLink_ES}  roomlink={this.state.roomSelected.videoLink_ES} onClick={(ev)=>this.onRoomVideoLinkClick(ev)} >Español</Button>
                                )}
                                {Utils.renderIf(this.state.roomSelected.videoLink_EN !=null,
                                    <Button active={this.state.roomSelected.videoLink_EN == this.state.roomLinkSelected} key={this.state.roomLinkSelected.videoLink_EN} roomlink={this.state.roomSelected.videoLink_EN} onClick={(ev)=>this.onRoomVideoLinkClick(ev)} >English</Button>
                                )}    
                                {Utils.renderIf(this.state.roomSelected.videoLink_PT !=null,
                                    <Button active={ this.state.roomSelected.videoLink_PT == this.state.roomLinkSelected} key={this.state.roomSelected.videoLink_PT} roomlink={this.state.roomSelected.videoLink_PT} onClick={(ev)=>this.onRoomVideoLinkClick(ev)} >Español</Button>
                                )} 
                            
                        </ButtonGroup>                                
                    :null}
                    </Col>
                   
                </Row>
                </div>
                <Row>
                    <Col sm={12}>
                    {
                    this.state.roomLinkSelected.match("hostradios") == null
                    && this.state.roomLinkSelected.match("vmf.edge-apps.net") == null 
                    && this.state.roomLinkSelected.match("vimeo") == null 
                    && this.state.roomLinkSelected.match("castr") == null 
                    ?
                    <div className='player-wrapper'>
                        <ReactPlayer autoPlay playing  controls={true} loop={true}
                            url={this.state.roomLinkSelected}                     
                            width='100%'
                            height='100%'
                            className="react-player"
                        />  
                    </div>
                    :
                    <iframe width="100%" style={{height:this.props.autoHideSelectionTabs==true?this.props.videoHeight:null}} className="vimeo-iframe" src={this.state.roomLinkSelected} frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                        allowfullscreen="allowfullscreen"></iframe>

                    }
                    </Col>

                </Row>
           
        </div>    
       );

    }
}

const mapStateToProps = state => {
    return { miniVideoPlayerIsShowing: state.miniVideoPlayer.show,
             locale: state.settings.locale };
	
};
export default connect(
	mapStateToProps,
    {miniVideoPlayerShow,miniVideoPlayerHide}
)(LiveStreamSelectionTabs);
